import {createApp} from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import {message} from "ant-design-vue";

//导入所有图标库
import * as Icons from "@ant-design/icons-vue";

message.config({
    maxCount: 1 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

// 重置样式表
import '@/style/reset.less'
// 公用样式表
import '@/style/common.less'

import App from './App.vue'
import router from './router'
import store from './store'

import dayjs from "dayjs";

dayjs.locale('zh-cn');


import './permission'

const app = createApp(App)

app.use(store).use(router).use(Antd)

Object.keys(Icons).forEach((key) => {
    app.component(key, Icons[key]);
})


app.mount('#app')